import React, { useState } from "react";
import {
  MDBNavbar,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavLink,
  MDBCollapse,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBHamburgerToggler,
} from "mdbreact";
import { useHistory } from "react-router-dom";

const Mobilemenu = () => {
  const history = useHistory();

  const [state, setState] = useState({
    collapse1: false,
    collapseID: "",
  });

  const toggleCollapse = (collapseID) => () => {
    setState((prevState) => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : "",
    }));
  };

  const toggleSingleCollapse = (collapseId) => {
    setState({
      ...state,
      [collapseId]: !state[collapseId],
    });
  };

  return (
    <MDBNavbar>
      <MDBHamburgerToggler
        id="hamburger1"
        onClick={() => toggleSingleCollapse("collapse1")}
      />
      <MDBCollapse isOpen={state.collapse1} navbar>
        <MDBNavbarNav left>
          <MDBNavItem active>
            <a
              className="nav-link"
              href="https://www.cognitude.co.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Home
            </a>
            {/* <MDBNavLink to="/">Home</MDBNavLink> */}
          </MDBNavItem>
          <MDBNavItem>
            <a
              className="nav-link"
              href="https://www.cognitude.co.in/about-us"
              target="_blank"
              rel="noopener noreferrer"
            >
              About Us
            </a>
            {/* <MDBNavLink to="https://www.cognitude.co.in/about-us" link={true}>About Us</MDBNavLink> */}
          </MDBNavItem>
          {/* <MDBNavItem>
            <MDBNavLink to="/our-services">Our services</MDBNavLink>
          </MDBNavItem> */}
          <MDBNavItem>
            <MDBDropdown>
              <MDBDropdownToggle nav caret>
                <span
                  className={`${
                    history.location.pathname === "/" ||
                    history.location.pathname === "/vulnerability-scan" ||
                    history.location.pathname === "/scan-result"
                      ? "active"
                      : ""
                  }`}
                >
                  Our services
                </span>
              </MDBDropdownToggle>
              <MDBDropdownMenu>
                <MDBDropdownItem
                  href="https://www.cognitude.co.in/ourservices/IT-security"
                  target="_blank"
                >
                  IT Solutions & Security Services
                </MDBDropdownItem>
                <MDBDropdownItem
                  href="https://www.cognitude.co.in/ourservices/IT-consulting"
                  target="_blank"
                >
                  IT & GenAI Consulting
                </MDBDropdownItem>
                <MDBDropdownItem
                  href="https://www.cognitude.co.in/ourservices/mobile-solution"
                  target="_blank"
                >
                  Mobile & POS Solutions
                </MDBDropdownItem>

                <MDBDropdownItem
                  href="/"
                  className={`${
                    history.location.pathname === "/" ||
                    history.location.pathname === "/vulnerability-scan" ||
                    history.location.pathname === "/scan-result"
                      ? "active"
                      : ""
                  }`}
                >
                  Vulnerability Scan
                </MDBDropdownItem>
                {/* <MDBDropdownItem
                  href="https://engineeringmarg.cognitude.co.in/"
                  target="_blank"
                >
                  Engineering College Predictor- Engineering Marg
                </MDBDropdownItem> */}
                <MDBDropdownItem
                  href="https://v2text.cognitude.co.in/"
                  target="_blank"
                >
                  Video to text Converter
                </MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown>
          </MDBNavItem>
          <MDBNavItem>
            <a
              className="nav-link"
              href="https://www.cognitude.co.in/careers"
              target="_blank"
              rel="noopener noreferrer"
            >
              Careers
            </a>
            {/* <MDBNavLink to="https://www.cognitude.co.in/careers" link={true}>Careers</MDBNavLink> */}
            {/* <MDBDropdown>
              <MDBDropdownToggle nav caret>
                <span>Careers</span>
              </MDBDropdownToggle>
              <MDBDropdownMenu>
                <MDBDropdownItem href='/careers'>Open Positions</MDBDropdownItem>
                <MDBDropdownItem href='/life-at-cognitude'>Life At Cognitude</MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown> */}
          </MDBNavItem>
          <MDBNavItem>
            <a
              className="nav-link"
              href="https://www.cognitude.co.in/contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact Us
            </a>
            {/* <MDBNavLink to="https://www.cognitude.co.in/contact" link={true}>Contact Us</MDBNavLink> */}
          </MDBNavItem>
        </MDBNavbarNav>
      </MDBCollapse>
    </MDBNavbar>
  );
};

export default Mobilemenu;
